import React, { createContext, useState } from 'react';

export const SelectionContext = createContext();

const SelectionProvider = ({ children }) => {
  const [selections, setSelections] = useState({});

  const updateSelections = (scheme, choice, numbers) => {
    setSelections((prevSelections) => ({
      ...prevSelections,
      [scheme]: {
        choice,
        numbers,
      },
    }));
  };

  return (
    <SelectionContext.Provider value={{ selections, updateSelections }}>
      {children}
    </SelectionContext.Provider>
  );
};

export default SelectionProvider;